import { render, staticRenderFns } from "./SgmManualResultModal.vue?vue&type=template&id=8201298a&"
import script from "./SgmManualResultModal.vue?vue&type=script&lang=js&"
export * from "./SgmManualResultModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports